import * as d3 from 'd3';
import { margin } from './defaults';
export function barRenderer(svgElement, graphData, opts) {
    const bounds = svgElement.getBoundingClientRect();
    const width = bounds.width - margin.left - margin.right;
    const height = bounds.height - margin.top - margin.bottom;
    const xDomain = graphData.dataSets[0].rows.map((row) => row.day.toISOString());
    // X axis
    const x = d3
        .scaleBand()
        .range([0, width])
        .domain(xDomain)
        .round(true)
        .padding(0.2);
    // Y axis
    const y = d3.scaleLinear().range([height, 0]).domain(graphData.yDomain).nice();
    // --------------------------------------------------------------------------
    // Main chart elements
    // Main container
    const svg = d3
        .select(svgElement)
        .attr('min-width', '200px')
        .attr('min-height', '200px');
    // Remove existing content
    svg.selectAll('*').remove();
    // Main SVG g element, translated to accommodate margins
    const svgGroup = svg
        .append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`);
    // --------------------------------------------------------------------------
    // Axes
    // Add x-axis to SVG
    svgGroup
        .append('g')
        .attr('class', 'xAxis')
        .attr('transform', `translate(0, ${height})`)
        .call(d3.axisBottom(x).ticks(30).tickSize(15).tickFormat(opts.xTickFormatter));
    // Add y-axis to SVG
    svgGroup
        .append('g')
        .attr('class', 'yAxis')
        .call(d3
        .axisLeft(y)
        .ticks(4)
        .tickSize(-width)
        .tickPadding(10)
        .tickFormat(opts.yTickFormatter));
    // Make 1st and last tick larger on x axis to set text position and hide them
    svgGroup
        .selectAll('.xAxis line')
        .attr('y2', (_d, i, selection) => i === 0 || i === selection.length - 1 ? 15 : 0)
        .attr('opacity', 0);
    // Only show every 1st and last number on the x axis
    // and position them inside the boundaries of the graph
    svgGroup
        .selectAll('.xAxis text')
        .attr('opacity', (_d, i, selection) => i === 0 || i === selection.length - 1 ? 1 : 0)
        .attr('x', (_d, i) => (i === 0 ? -x.bandwidth() / 2 : x.bandwidth() / 2))
        .attr('text-anchor', (_d, i) => (i === 0 ? 'start' : 'end'));
    // --------------------------------------------------------------------------
    // Main chart drawing
    graphData.dataSets.forEach((dataSet) => {
        // Datasets
        const datasetSelection = svgGroup
            .selectAll('.bar-dataset')
            .data(dataSet.rows)
            .enter();
        // Add the dataset rectangles
        datasetSelection
            .append('rect')
            .attr('class', 'bar-chart-rect')
            .attr('x', (row) => x(row.day.toISOString() || '') || '')
            .attr('y', (row) => y(row.value) ?? 0)
            .attr('height', (row) => height - (y(row.value) ?? 0))
            .attr('width', x.bandwidth())
            .attr('fill', (row) => row.dataSet.color)
            .on('mousemove', (_row, i) => opts.onHover?.(graphData.dataSets.map((ds) => ds.rows[i])))
            .on('mouseleave', () => opts.onHover?.(undefined));
    });
}
